import React, { useState } from 'react';
import { IonItem, IonInput, IonIcon } from '@ionic/react';
import { eyeOutline, eyeOffOutline } from 'ionicons/icons';

interface PasswordInputProps {
  placeholder: string;
  value: string;
  onValueChange: (value: string) => void;
  onKeyDown?: (e: React.KeyboardEvent) => void;
}

const PasswordInput: React.FC<PasswordInputProps> = ({ placeholder, value, onValueChange, onKeyDown }) => {
  const [visible, setVisible] = useState(false);

  return (
    <IonItem>
      <IonInput
        placeholder={placeholder}
        type={visible ? 'text' : 'password'}
        value={value}
        onIonInput={(e) => onValueChange(e.detail.value ?? '')}
        onKeyDown={onKeyDown}
      />
      <button
        type="button"
        slot="end"
        onClick={() => setVisible((v) => !v)}
        aria-label={visible ? 'Ocultar contraseña' : 'Mostrar contraseña'}
        style={{ background: 'none', border: 0, padding: 8, cursor: 'pointer', display: 'flex', alignItems: 'center' }}
      >
        <IonIcon icon={visible ? eyeOffOutline : eyeOutline} style={{ fontSize: 20, color: 'var(--ion-color-medium)' }} />
      </button>
    </IonItem>
  );
};

export default PasswordInput;
